import { render, staticRenderFns } from "./PurchaseRequisitionForm.vue?vue&type=template&id=19e3c0c8"
import script from "./PurchaseRequisitionForm.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports